import tinycolor from 'tinycolor2';

import * as theme from './theme';

const BRIGHTNESS_THRESHOLD = 145;

export function shouldTextBeLight(backgroundColor: string) {
	return tinycolor(backgroundColor).getBrightness() < BRIGHTNESS_THRESHOLD;
}

export function contrastingTextColor(backgroundColor: string): string {
	return shouldTextBeLight(backgroundColor)
		? theme.colors.white
		: theme.colors.text.primary;
}

export function nameToHash(name: string): string {
	if (name === undefined || name === null) return '#000000';
	let hash = 0;
	for (let i = 0; i < name.length; i++) {
		hash = name.codePointAt(i)! + ((hash << 5) - hash);
	}
	let color = '#';
	for (let i = 0; i < 3; i++) {
		const value = (hash >> (i * 8)) & 0xff;
		color += ('00' + value.toString(16)).slice(-2);
	}

	return color;
}
